import Cookies from 'js-cookie';
import { Controller } from 'stimulus';
import events from 'lib/events';
import {
  getFormattedPageValue, triggerCustomEvent, ezFadeOut,
} from 'lib/helpers';
import SearchStateManager from 'lib/search-state';

const searchState = new SearchStateManager();

export default class SearchController extends Controller {
  connect() {
    this.currentlyAjaxing = false;
    this.searchOverlayHtml = '<div class="filters-overlay" data-search-loading="true"><div class="ez-spinner ez-spinner"></div></div>';

    this.addLoadingOverlay(true);

    window.addEventListener('PostSearchAjax', this.postAjaxEvent);
    window.addEventListener('SearchPaginationChange', this.searchPaginationEvent);
    window.addEventListener('Searched', this.performSearch);
    window.addEventListener('click', this.trackSearchClick);
    window.addEventListener(events.search.apply_filters, this.applySearchFilters);
  }

  disconnect() {
    window.removeEventListener('PostSearchAjax', this.postAjaxEvent);
    window.removeEventListener('SearchPaginationChange', this.searchPaginationEvent);
    window.removeEventListener('Searched', this.performSearch);
    window.removeEventListener('click', this.trackSearchClick);
    window.removeEventListener(events.search.apply_filters, this.applySearchFilters);
  }

  applySearchFilters() {
    const searchInput = document.querySelector('#search');
    const queryString = searchState.getFlatQueryString();
    const term = encodeURIComponent(searchInput.value.replace(/ /g, '-'));
    const { searchRoute } = searchInput.dataset;
    const { protocol, host } = window.location;
    const newSearchUrl = `${protocol}//${host}/${searchRoute}/${term}${queryString}`;
    Cookies.set('ezSearchType', 'internal');
    Turbolinks.visit(newSearchUrl);
  }

  postAjaxEvent = (event) => {
    this.postAjax(event.detail.dataHash);
  }

  searchPaginationEvent = (event) => {
    triggerCustomEvent('PaginationChanged', {
      page: event.detail.page,
      stateKey: 'search-state',
      extraStates: ['filterState'],
      ajaxEventName: 'PostSearchAjax',
    });
  }

  performSearch = (event) => {
    const searchRoute = event.detail.searchRoute ? event.detail.searchRoute : 'search';
    let searchUrl = `/${searchRoute}/${encodeURIComponent(event.detail.term.replace(/ /g, '-'))}`;
    let searchQuery = '';

    Cookies.set('ezSearchType', 'internal');

    // If search contains new filter params
    if (event.detail.useSearchState) {
      searchQuery = searchState.getFlatQueryString();
    }
    searchUrl += searchQuery;

    if (event.detail.searchInNewTab === true) {
      window.open(searchUrl, '_blank');
    } else {
      // TODO: Use Turbolinks here, adjust Internal/External search tracking
      window.location.assign(searchUrl);
    }
  }

  addLoadingOverlay(fadeOut) {
    const searchResultsContainer = document.querySelector('.search-results__main');

    if (!searchResultsContainer) {
      return;
    }

    searchResultsContainer.insertAdjacentHTML(
      'afterBegin',
      this.searchOverlayHtml,
    );

    if (fadeOut) {
      const filterLoadingOverlay = document.querySelector('[data-search-loading=true]');

      if (filterLoadingOverlay) {
        ezFadeOut(filterLoadingOverlay, 30, () => {
          filterLoadingOverlay.parentNode.removeChild(filterLoadingOverlay);
        });
      }
    }
  }

  openOffscreenFilters() {
    const openOffscreenFiltersEvent = new CustomEvent('OpenOffscreenFilters');
    window.dispatchEvent(openOffscreenFiltersEvent);
  }

  postAjax = (dataHash) => {
    if (!this.currentlyAjaxing) {
      this.currentlyAjaxing = true;
      this.addLoadingOverlay();

      searchState.updateStateValue('page', dataHash.page);
      const queryParams = searchState.getFlatQueryString();

      if (this.searchType) {
        Cookies.set('ezSearchType', this.searchType);
      }

      window.location.assign(window.location.pathname + queryParams);
    }
  };

  footerPagerChange() {
    event.preventDefault(); // eslint-disable-line no-restricted-globals

    const curPageValue = document.querySelector(
      '[data-target="ez-num-pager.currentPage"]',
    );
    const nextPageValue = parseInt(getFormattedPageValue(curPageValue), 10) + 1;

    triggerCustomEvent('SearchPaginationChange', { page: nextPageValue });
  }

  trackSearchClick = (event) => {
    const gridItem = event.target.closest('.search-results__main .ez-resource-grid__item');
    if (gridItem) {
      triggerCustomEvent(events.search.click, {
        resourceId: gridItem.getAttribute('data-item-id'),
        resourcePosition: gridItem.getAttribute('data-position'),
        resourcePro: gridItem.getAttribute('data-pro'),
        searchTerm: this.searchTerm,
      });
    }
  }

  get searchTerm() {
    const searchInfo = this.element.querySelector('[data-search-term]');
    if (searchInfo) {
      return searchInfo.getAttribute('data-search-term');
    }

    return '';
  }

  get searchType() {
    const searchInfo = this.element.querySelector('[data-search-type]');
    if (searchInfo) {
      return searchInfo.getAttribute('data-search-type');
    }

    return null;
  }
}
